import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const useConfig = () => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()

  const options = [
    defaultSortingOption,
    {
      value: 'legalEntityName',
      label: t('consultations.institution_name_asc')
    },
    {
      value: '-legalEntityName',
      label: t('consultations.institution_name_desc')
    },
    {
      value: 'consultationType',
      label: t('consultations.consultation_type_asc')
    },
    {
      value: '-consultationType',
      label: t('consultations.consultation_type_desc')
    }
  ]

  return { options }
}
